import {navigate, RouteComponentProps} from '@reach/router'
import {useTranslation} from 'react-i18next'
import { useEffect, useState } from 'react'
import {IAuthService} from 'modules/auth/services/AuthService'
import {URL_CLINICS, URL_IMMUNOCOM, URL_KITS_BEDFILE, URL_PATIENTS, URL_PATIENTS_INMUNOCOM, URL_PATIENTS_PGD, URL_PATIENTS_PGSEC, URL_PGD_TEST, URL_PGSEC_TEST, URL_RECEPTIVENESS, URL_SCRIPT, URL_USERS} from '../../routes/routes-constants'
import {AUTH_SERVICE_KEY} from '../../modules/auth'
import {getAuthContainer} from '../../container/auth-modules'
import { Accordion, AccordionDetails, AccordionSummary,Button, Grid, makeStyles } from '@material-ui/core'
import { Permission } from 'common/enums/Permissions'
import { Query, QueryParam } from 'common/api/Query'
import { ClinicQuery } from 'modules/clinics/models/Clinic'
import { getClinicContainer } from 'container/clinic-modules'
import { ClinicService } from 'modules/clinics/services/ClinicService'
import { CLINIC_SERVICE_KEY } from 'modules/clinics'

const authService = getAuthContainer().get<IAuthService>(AUTH_SERVICE_KEY)
const clinicService = getClinicContainer().get<ClinicService>(CLINIC_SERVICE_KEY)

export const Home = (props: RouteComponentProps) => {
    const classes = useStyles()
    const {t} = useTranslation()
      const [receptiveness, setReceptiveness] = useState<boolean>(true)
      const [pdg, setPdg] = useState<boolean>(true)
      const [pgsec, setPgsec] = useState<boolean>(true)
      const [inmunocom, setInmunocom] = useState<boolean>(true)
    
    
      useEffect(() => {
          const user = authService.get();
          if (user && Array.isArray(user.permissions) && user.permissions.includes(Permission.viewReceptiveness)) {
            return;
          }
    
          const query: QueryParam<ClinicQuery>[] = []
          if (user && Array.isArray(user.permissions) && !user.permissions.includes(Permission.viewAll)) {
            query.push(new QueryParam<ClinicQuery>('ids', authService.get().clinics))
          }
        
          clinicService
            .getFilteredList(
              new Query({
                pager: { offset: 0, limit: 1}, 
                query,
                sort: [{ field: 'name' }],
              })
            )
            .subscribe((res) => {
              setReceptiveness(res.items.some((cl) => cl.activeReceptiveness));
              setPdg(res.items.some((cl) => cl.activePgd));
              setPgsec(res.items.some((cl) => cl.activePgsec));
              setInmunocom(res.items.some((cl) => cl.activeInmunocom));
            });
        }, [])


    const handleClinics = () => {
      window.location.href = URL_CLINICS
      navigate(URL_CLINICS)
    }

    const handleIndiPgd = () => {
      window.location.href = URL_PATIENTS_PGD
      navigate(URL_PATIENTS_PGD)
    }
    const handleIndiRecep = () => {
      window.location.href = URL_PATIENTS
      navigate(URL_PATIENTS)
    }
    const handleIndiInmuno = () => {
      window.location.href = URL_PATIENTS_INMUNOCOM
      navigate(URL_PATIENTS_INMUNOCOM)
    }
    const handleIndiPgseq = () => {
      window.location.href = URL_PATIENTS_PGSEC
      navigate(URL_PATIENTS_PGSEC)
    }
    
    const handleTestPgd = () => {
      window.location.href = URL_PGD_TEST
      navigate(URL_PGD_TEST) 
    }
    const handleTestRecep = () => {
      window.location.href = URL_RECEPTIVENESS
      navigate(URL_RECEPTIVENESS) 
    }
    const handleTestInmuno = () => {
      window.location.href = URL_IMMUNOCOM
      navigate(URL_IMMUNOCOM) 
    }
    const handleTestPgseq = () => {
      window.location.href = URL_PGSEC_TEST
      navigate(URL_PGSEC_TEST) 
    }
    
    const handleusers = () => {
      window.location.href = URL_USERS
      navigate(URL_USERS) 
    }
    const handleScri = () => {
      window.location.href = URL_SCRIPT
      navigate(URL_SCRIPT) 
    }
    const handleKits = () => {
      window.location.href = URL_KITS_BEDFILE
      navigate(URL_KITS_BEDFILE) 
    }


    return (
        <Grid className={classes.container}>
            <Button className={classes.button} onClick={handleClinics}>
              <img
                src="/icons/icon-clinics.svg"
                alt="icon"
                className={classes.icon}
                style={{width: '50px'}}  
                />
                {t('clinics')}
            </Button>
            
            <Accordion className={classes.acordion}>
              <AccordionSummary className={classes.button}
                  aria-controls="panel1-content"
                  id="panel1-header"
              >
                <Button className={classes.button} >
                  <img
                    src="/icons/icon-patients.svg"
                    alt="icon"
                    className={classes.icon}
                  />
                  {t('individuals')}
              </Button>

              </AccordionSummary>
              <AccordionDetails className={classes.acordion}>
              {pdg && (
                <Button className={classes.button} onClick={handleIndiPgd}>
                  {t('pgdseq')}
                </Button>
              )}     
              {receptiveness && (
                <Button className={classes.button} onClick={handleIndiRecep}>
                  {t('Receptivity')}
                </Button>  
              )}
              {inmunocom && (
                <Button className={classes.button} onClick={handleIndiInmuno}>
                  {t('inmunocompatibility')}
                </Button>
              )}      
              {pgsec && (
                <Button className={classes.button} onClick={handleIndiPgseq}>
                  {t('PG-Seq Core Panel')}
                </Button>
              )}                     
              </AccordionDetails>
            </Accordion>

            <Accordion className={classes.acordion}>
              <AccordionSummary className={classes.button}
                  aria-controls="panel1-content"
                  id="panel1-header"
              >
             <Button className={classes.button}>
              <img
                src="/icons/icon-reports.svg"
                alt="icon"
                className={classes.icon}
              />
              {t('tests')}
            </Button>
              </AccordionSummary>
              <AccordionDetails className={classes.acordion}>
              {pdg && (
                <Button className={classes.button} onClick={handleTestPgd}>
                  {t('pgdseq')}
                </Button>
              )}     
              {receptiveness && (
                <Button className={classes.button} onClick={handleTestRecep}>
                    {t('Receptivity')}
                </Button>
              )} 
              {inmunocom && (
                <Button className={classes.button} onClick={handleTestInmuno}>
                  {t('inmunocompatibility')}
                </Button>
              )}      
              {pgsec && (
                <Button className={classes.button} onClick={handleTestPgseq}>
                  {t('PG-Seq Core Panel')}
                </Button>
              )}                     
              </AccordionDetails>
            </Accordion>

         {(           
             <Accordion className={classes.acordion}>
              <AccordionSummary className={classes.button}
                  aria-controls="panel1-content"
                  id="panel1-header"
              >
              <Button className={classes.button}>
                <img
                    src="/icons/icon-settings.svg"
                    alt="icon"
                    className={classes.icon}
                    />
                {t('Settings')}
            </Button>
              </AccordionSummary>
              <AccordionDetails className={classes.acordion}>
                {authService.userCan(Permission.editUsers) &&  <Button className={classes.button} onClick={handleusers}>
                  {t('users')}
                </Button>}    
                {authService.userCan(Permission.changeScript) && <Button className={classes.button} onClick={handleScri}>
                    {t('Script')}
                </Button>  }

                 <Button className={classes.button} onClick={handleKits}>
                    {t('downloadKits')}
                </Button> 


                
              </AccordionDetails>
            </Accordion>
           ) 

            }
         </Grid>
    )
}

const useStyles = makeStyles((theme) => ({

  container: {
     display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-around',
  marginTop: '450px',
  // height: '70vh',
  // overflowY: 'auto',
  // backgroundColor: "red !important"
    
  },
  sidebarmenu: {
    marginTop: theme.spacing(5),
  },
  drawer: {
    background: theme.palette.grey.A100,
    position: 'static',
    transition: 'width .7s',
    width: '250px',
  },
  button: {
    background: theme.palette.grey.A100,
    border: 0,
    borderRadius: '10px',
    width: '275px',
    height: '70px',
    display:'flex',
    justifyContent:'left',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.grey.A100, // mismo color de fondo
      boxShadow: 'none',
      opacity: 1,
    },
  },
  icon:{
    marginLeft: '20px',
    marginRight: '30px' 
  },
  acordion:{
    background: theme.palette.grey.A100,
    border: 0,
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    nWidth: '275px',
    Width: '275px', 
    '&:before': {
    display: 'none', 


  },

    
  },
  acordionTitle: {
    textAlign: 'center',
    fontSize: '20px'
  }
}))